import React from 'react';
import TestimonialsSliderClient from './TestimonialsSliderClient';
import { TestimonialsType } from '@lib/sanity/queries/modules/testimonials/types';
import Container from '@ui/Container/Container';
import Testimonial from './Testimonial';

export const DEFAULT_AUTO_PLAY_DELAY = 6;

export default function TestimonialsSlider({ data }: { data: TestimonialsType }) {
  if (!data.testimonials?.length) {
    return;
  }

  const testimonials = data.testimonials.map((testimonial, i) => {
    return <Testimonial key={i} testimonial={testimonial} />;
  });
  const autoplayDelay = data.autoplayDelay ?? DEFAULT_AUTO_PLAY_DELAY;

  return (
    <Container theme={data.theme} className="bg-background py-16" removeContainer>
      <TestimonialsSliderClient testimonials={testimonials} autoplayDelay={autoplayDelay} />
    </Container>
  );
}
